import React, { useState } from 'react'
import IconChevronDown from '@/components/IconChevronDown'

type Props = {
  children: React.ReactNode
  heading: string
  className?: string
  useBorder?: boolean
  as?: 'h4' | 'span'
  compact?: boolean
}

function AccordionChild({
  children,
  heading,
  className = '',
  useBorder = true,
  as = 'span',
  compact = false
}: Props): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false)

  const handleClick = () => {
    setIsExpanded(!isExpanded)
  }

  const Heading = as

  return (
    <div
      className={`
        ${
          useBorder
            ? 'border-b border-gray-300 bg-white pb-4 lg:last:border-0 lg:last:pb-0'
            : ''
        } ${className}
      `}
    >
      <h4
        className={`flex w-full cursor-pointer items-center justify-between gap-4 text-left font-medium text-gray-1100 ${
          compact
            ? 'text-lg leading-6 lg:text-base lg:font-normal'
            : 'text-base'
        }`}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        aria-expanded={isExpanded}
      >
        {heading}
        <div className={isExpanded ? 'rotate-180' : ''}>
          <IconChevronDown
            className={`text-gray-1100 ${compact ? 'lg:size-6' : 'size-4'}`}
          />
        </div>
      </h4>

      <div
        className={`pt-2 text-gray-800 ${isExpanded ? '' : 'hidden'} ${
          compact
            ? 'text-base leading-6 lg:text-sm lg:leading-5'
            : 'text-sm lg:mt-0.5'
        }`}
      >
        {children}
      </div>
    </div>
  )
}

export default AccordionChild
